module.exports = __webpack_public_path__ + "5e20592ff443f57e7bab4cb02e8a4d24.jpg";